interface GraphWithDollarSignSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphWithDollarSignSVG = ({
  color,
  style,
}: GraphWithDollarSignSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46459)">
      <path
        d="M40.011 34.5613C40.011 33.3624 39.0301 32.3815 37.8312 32.3815C36.6323 32.3815 35.6514 33.3624 35.6514 34.5613V35.3896C35.6514 36.218 36.12 36.97 36.8612 37.3406L38.8121 38.3106C39.5533 38.6812 40.0219 39.4332 40.0219 40.2616V41.0899C40.0219 42.2888 39.041 43.2698 37.8421 43.2698C36.6432 43.2698 35.6623 42.2888 35.6623 41.0899"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.8311 32.3814V29.1117"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.8311 43.2806V46.5504"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M42.1903 0.773865L30.2012 12.763L25.8416 8.40329L14.9424 19.3025L8.40287 12.763L0.773438 20.3924"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M1.86328 33.4714V23.6621"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.40332 33.4714V18.2125"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.9424 33.4714V23.6621"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M21.4824 33.4714V19.3024"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M28.0215 29.1117V16.0327"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.5615 24.752V13.8528"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M41.1006 24.752V7.31335"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.831 50.9101C45.0543 50.9101 50.91 45.0544 50.91 37.831C50.91 30.6077 45.0543 24.752 37.831 24.752C30.6076 24.752 24.752 30.6077 24.752 37.831C24.752 45.0544 30.6076 50.9101 37.831 50.9101Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M44.3701 37.8311H46.55"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M29.1113 37.8311H31.2912"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46459">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphWithDollarSignSVG;
